<div>

  <app-app-dashboard-navigation></app-app-dashboard-navigation>

  <div class="dash-section m-5 p-3 bg-white">
    <div class="m-4">
      <div class="col font-weight-bold text-black-50 ">
        Agronomical Info Headings
      </div>
    </div>
  </div>

  <!-- <app-post-diagnosis-modal [category]="category" (reloadDiagnosisEvent)="refreshDiagnosisList()">
  </app-post-diagnosis-modal> -->

  <div class="dash-section m-5 bg-white">
    <div class="col  ">
      <div class="row dash-section px-5 ">
        <div class="col p-2">
          <h3 class="mt-4 py-3 float-left">Agronomical Info Headings</h3>
          <button class="float-right btn background text-white my-3 mt-5 mr-2" data-toggle="modal"
            data-target="#agroModal">
            <i class="fas fa-plus mr-2"></i>Create Heading
          </button>
        </div>
      </div>
      <div class="row dash-section px-5">
        <div class="container">
          <p-table #diagnosisT
          [value]="data"
          [paginator]="true"
          [rows]="10"
          [loading]="loading"
          [rowsPerPageOptions]="[10,20,30,40,50]"
          class="table table-striped table-hover"
          >
          <!-- <table class="table table-striped table-hover"> -->
            <!-- <thead class="table_head"> -->
              <ng-template pTemplate="caption"  >
                <div class="row" style="width: 100%;">
                  <div class="col-sm-6 ui-g ui-fluid">
                    <!-- <i class="pi pi-search" style="margin:4px 4px 0 0"></i> -->
                    <div class="ui-g-12 ui-md-12">
                      <h6>{{ type }}</h6>
                      <p-multiSelect
                      id="nameselect"
                      #nameselect="ngModel"
                      [(ngModel)]="selectedName"
                      [options]="namesToSelect"
                      defaultLabel="All"
                      (onChange)="diagnosisT.filter($event.value, 'name', 'in')">
                      </p-multiSelect>
                    </div>


                  </div>
                  <div class="col-sm-6">
                    <p>&nbsp;</p>
                    <button
                    (click)="Clear(diagnosisT)"

                    style="float: right;"
                    class="btn btn-md bg-dark disabled text-white clear"
                    >
                    Clear Filters
                    </button>
                  </div>

                </div>
            </ng-template>
            <ng-template pTemplate="header" class="table_head">
              <tr>
                <th scope="col" style="width: 40px; background-color: rgb(89, 170, 233);color: white;">#</th>
                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">
                  Heading Name
                </th>
                <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Action</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td> {{ data.indexOf(row)+1 }}</td>
                <td>{{ row.name }}</td>

                <td>
                  <div class="dropdown">
                    <button class="btn btn-outline-info dropdown-toggle" type="button" id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="clearMessage()">
                      ACTION
                    </button>
                    <div class="dropdown-menu options" aria-labelledby="dropdownMenuButton">
                      <a class="dropdown-item" data-toggle="modal" data-target="#editSmartModal"
                        (click)="setHeadingAction(row)">
                        Edit/Delete
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
            <ng-template #spinnerDiv>
              <tbody>
                <tr>
                  <td colspan="8">
                    <div class="spinner d-flex">
                      <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </ng-template>
        </div>
      </div>
    </div>
    <div class="m-4">&nbsp;</div>
  </div>
  <div class="m-4">&nbsp;</div>
  <!--Add smart diagnosis-->

  <div class="modal fade" id="agroModal">
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 50%;">
      <div class="card modal-content">
          <div class="modal-header">
              <h4 class="modal-title text-info" id="modal-basic-title">Create New Heading</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>

          <div class="modal-body" *ngIf="createHeadingisSuccess" style="text-align: center; padding: 3rem 0 3rem 0;">
              <i class="far fa-check-circle fa-3x" style="color: teal; padding: 1rem 0 1rem 0"></i>
              <h4>Success!</h4>
              <p><span class="text-center">Heading Created successfully</span></p>
              <button class="btn btn-success px-3 filter-teal-bg text-white" data-dismiss="modal" (click)="resetModal()">OK</button>
          </div>

          <div class="modal-body agronomical-view-details" *ngIf="!createHeadingisSuccess">
            <span class="text-center alert alert-danger" *ngIf="serverError">{{ message }}</span>
            <div class="container-fluid">
              <form
              #createDiagnosisForm="ngForm"
              (submit)="handleSubmit(createDiagnosisForm.value)"
              id="diagnosisForm"
            >

              <div class="form-group">
                <label for="diagnosisName">Heading Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="diagnosisPart"
                  aria-describedby="nameHelp"
                  name="name"
                  #name="ngModel"
                  ngModel
                  required
                />
              </div>


              <div class="my-3 d-flex flex-row-reverse">
                <button
                  type="button"
                  class="btn btn-secondary ml-3"
                  data-dismiss="modal"
                  (click)="closeModal()"
                >
                  CANCEL
                </button>
                <button
                  type="submit"
                  class="btn button-color text-white"
                  [disabled]="!createDiagnosisForm.form.valid"
                >
                <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
                </span>
                  SAVE INFO
                </button>
              </div>
            </form>
              </div>
          </div>
        <div class="modal-footer" *ngIf="!createHeadingisSuccess">
          <button type="button" class="btn btn-warning" data-dismiss="modal">
            <span class="text-white">CLOSE</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Delete modal -->
  <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="deleteDiagnosisModal"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content" *ngIf="headingDeleteData">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteDiagnosisModal">Delete Heading</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body" *ngIf="!deleteHeadingloading && !message">
          <span class="text-center" *ngIf="message">{{ message }}</span>
          Are you sure you want to delete <span class="font-weight-bold">{{ headingDeleteData.name }}</span>
        </div>
        <div class="modal-body" *ngIf="message">
          <span class="text-center">{{ message }}</span>
        </div>
        <div class="spinner d-flex" *ngIf="deleteHeadingloading">
          <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
        </div>
        <div class="modal-footer" *ngIf="!deleteHeadingloading">
          <button type="button" class="btn btn-danger" (click)="deleteHeading(headingDeleteData.id)"
            *ngIf="!message">Delete {{ category | titlecase }}</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" *ngIf="!message">Close</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="resetDeleteModal()" *ngIf="message">Ok
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--Edit smart diagnosis data-->
  <div class="modal fade" id="editSmartModal">
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 50%;">
      <div class="card modal-content">
          <div class="modal-header">
              <h4 class="modal-title text-info" id="modal-basic-title">Edit Details</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>

          <div class="modal-body" *ngIf="editHeadingisSuccess" style="text-align: center; padding: 3rem 0 3rem 0;">
              <i class="far fa-check-circle fa-3x" style="color: teal; padding: 1rem 0 1rem 0"></i>
              <h4>Success!</h4>
              <p><span class="text-center">Heading edited successfully</span></p>
              <button class="btn btn-success px-3 filter-teal-bg text-white" data-dismiss="modal" (click)="resetEditModal()">OK</button>
          </div>

          <div class="modal-body agronomical-view-details" *ngIf="!editHeadingisSuccess">
            <span class="text-center alert alert-danger" *ngIf="editError">{{ message }}</span>
            <div class="container-fluid" *ngIf="editHeadingInfoData">
              <form *ngIf="editHeadingInfoData" (submit)="handleEdit(updateSmartForm.value, editHeadingInfoData.id)" #updateSmartForm="ngForm"
              class="px-2 py-2">
              <div class="form-group">
                <label for="crop">Heading</label>
                <input type="text" class="form-control change-input-field" placeholder="name of heading" name="name"
                  value="{{ editHeadingInfoData.name }}" #name="ngModel" [(ngModel)]="editHeadingInfoData.name" minlength="3"/>
              </div>

              <div class="d-flex justify-content-center align-item-center form-group">
                <button type="submit" class="submit-input-btn" >
                  <span *ngIf="loading" class="spinner-border spinner-border-md
                    text-white change-loading" role="status"></span>
                  <span *ngIf="loading" class="mx-2">Loading...</span>
                  <span *ngIf="!loading">
                    Save Info
                  </span>
                </button>
              </div>
            </form>
              </div>
          </div>
        <div class="modal-footer" *ngIf="!editHeadingisSuccess">
            <a
            class="btn btn-danger text-white"
            data-dismiss="modal"
            data-toggle="modal"
            data-target="#deleteModal"
            (click)="deleteInfoDetails( editHeadingInfoData )"
            >Delete</a
            >
          <button type="button" class="btn btn-warning" data-dismiss="modal">
            <span class="text-white">CLOSE</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
